import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
import * as SwitchPrimitive from "@radix-ui/react-switch";
type Props = {
  id: string;
  label?: string;
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
} & React.ComponentProps<"div">;
export function Switch(props: Props) {
  const {
    label,
    id,
    checked,
    onCheckedChange,
    disabled,
    ...rest
  } = props;
  return <_StyledDiv {...rest} $_css={[{
    "display": "flex",
    "width": "100%",
    "alignItems": "center",
    "justifyContent": "space-between",
    "padding": "2.4rem"
  }]}>
      <_StyledLabel htmlFor={id}>
        {label}
      </_StyledLabel>
      <_StyledDiv2>
        <_StyledSwitchPrimitiveRoot checked={checked} onCheckedChange={onCheckedChange} id={id}>
          <_StyledSwitchPrimitiveThumb />
        </_StyledSwitchPrimitiveRoot>
      </_StyledDiv2>
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-1bmnmlr-0"
})`${p => p.$_css}`;
var _StyledLabel = _styled2("label").withConfig({
  componentId: "sc-sf-1bmnmlr-1"
})({
  "cursor": "pointer",
  "fontSize": "1.4rem",
  "lineHeight": "1",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "400"
});
var _StyledDiv2 = _styled3("div").withConfig({
  componentId: "sc-sf-1bmnmlr-2"
})({
  "position": "relative",
  "height": "2.4rem",
  "width": "4.6rem",
  "borderRadius": "2px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(227 227 240 / var(--tw-bg-opacity))"
});
var _StyledSwitchPrimitiveRoot = _styled4(SwitchPrimitive.Root).withConfig({
  componentId: "sc-sf-1bmnmlr-3"
})({
  "height": "100%",
  "width": "100%",
  "borderRadius": "2px",
  "padding": "0.4rem",
  "outline": "2px solid transparent",
  "outlineOffset": "2px",
  "&[data-state=checked]": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))"
  }
});
var _StyledSwitchPrimitiveThumb = /*#__PURE__*/_styled5(SwitchPrimitive.Thumb).withConfig({
  displayName: "switch___StyledSwitchPrimitiveThumb",
  componentId: "sc-1w2efey-0"
})({
  "display": "block",
  "height": "1.6rem",
  "width": "1.9rem",
  "--tw-translate-x": "0.125rem",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
  "borderRadius": "2px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
  "transitionProperty": "transform",
  "transitionDuration": "250ms",
  "willChange": "transform",
  "&[data-state=checked]": {
    "--tw-translate-x": "19px",
    "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(227 227 240 / var(--tw-bg-opacity))"
  }
});